.customer-organization-form__sales-channel__sales-channel-inputs-container {
  width: 360px;
}
